import { render, staticRenderFns } from "./transactionLogManageList.vue?vue&type=template&id=2270db92&scoped=true"
import script from "./transactionLogManageList.vue?vue&type=script&lang=js"
export * from "./transactionLogManageList.vue?vue&type=script&lang=js"
import style0 from "./transactionLogManageList.vue?vue&type=style&index=0&id=2270db92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2270db92",
  null
  
)

export default component.exports